<template>
    <div>
        <h4>กรุณาสแกน QR CODE ด้วย สมาร์ทโฟน</h4>
        <!-- <img class="image-hover py-2" :src="linkQrCode" alt="qrcode" width="250" height="250"> -->
        <i class="fas fa-circle-notch fa-spin text-primary" v-if="loadQrCode"></i>
        <div class="image-hover py-2" v-html="linkQrCode" v-else>
        </div>
        <div class="pt-2">
            หรือ
            <div class="pt-2" v-if="hasBrowser">
                <a class="btn btn-info" :href="linkBrowser" target="_blank">
                    เปิดบนเว็บเบราว์เซอร์
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShowQrCode',
    props:{
        loadQrCode: Boolean,
        linkQrCode: String,
        hasBrowser: Boolean,
        linkBrowser: String,
    }
}
</script>
